import {Form} from "react-bootstrap";
import React from "react";
import Password from "./passwordForm";

const UserForm = ({setTitle, title, setName, name, setEmail, setSurname, surname, setPassword, setCheckPassword, editMode = false}) =>{

        return (
            <>
                <div>
                    <Form.Label>Titolo sociale*</Form.Label>
                    <div key={`inline-radio`} className="mb-3">
                        <Form.Check
                            inline
                            label="Sig."
                            name="title"
                            type='radio'
                            id='male'
                            checked={title === "Sig."}
                            onChange={e => e.target.checked? setTitle("Sig."): null}
                        />
                        <Form.Check
                            inline
                            label="Sig.ra"
                            name="title"
                            type="radio"
                            id="female"
                            checked={title === "Sig.ra"}
                            onChange={e => e.target.checked? setTitle("Sig.ra"): null}
                        />
                    </div>
                </div>

                <Form.Group className="mb-3" controlId="name">
                    <Form.Label>Nome*</Form.Label>
                    <Form.Control type="text" value={name} placeholder="Scrivi qui..." onChange={(value) => setName(value.target.value)}/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="surname">
                    <Form.Label>Cognome*</Form.Label>
                    <Form.Control type="text" placeholder="Scrivi qui..." value={surname} onChange={(value) => setSurname(value.target.value)} />
                </Form.Group>

                {!editMode &&
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>E-mail*</Form.Label>
                        <Form.Control type="email" placeholder="Scrivi qui..." onChange={(value) => setEmail(value.target.value)} />
                    </Form.Group>
                }

                {/*editMode &&
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>*</Form.Label>
                        <Form.Control type="email" placeholder="Scrivi qui..." onChange={(value) => setEmail(value.target.value)} />
                    </Form.Group>*/
                }


                <div className={'mb-3'}>
                    <Password label={'Password'} event={setPassword}/>
                </div>

                <div className={'mb-3'}>
                    <Password label={'Conferma password'} event={setCheckPassword}/>
                </div>
            </>
        );
}
export default UserForm;
